// ============================================================================
// BOOK · the open/closed state of the full-screen book (Zustand)
// ============================================================================
// AppOverlays remounts on every entryPhase change, so the open state cannot be
// local state (the same reason useNamesLinkOpen keeps a module flag).
// `?book=<key>` is written while the book is open, so a refresh or a shared
// link opens the same book; closing removes it. The header's Sun | Optic switch
// is openBook(<the other key>) — the address follows (CLB-104, David 24.10).
// ============================================================================
import { create } from 'zustand';
import { BOOKS, DEFAULT_BOOK } from './model/bookConstants';

function writeAddress(bookKey) {
  try {
    const u = new URL(window.location.href);
    if (bookKey) u.searchParams.set('book', bookKey); else u.searchParams.delete('book');
    window.history.replaceState(window.history.state, '', `${u.pathname}${u.search}${u.hash}`);
  } catch (_) { /* cosmetic */ }
}

export const useBookStore = create((set) => ({
  open: false,
  bookKey: DEFAULT_BOOK,
  openBook: (bookKey = DEFAULT_BOOK) => {
    if (!BOOKS[bookKey]) return;
    writeAddress(bookKey);
    set({ open: true, bookKey });
  },
  closeBook: () => { writeAddress(null); set({ open: false }); },
}));

export const openBook = (bookKey) => useBookStore.getState().openBook(bookKey);
